function getWindowSize() {
  if (typeof window === "undefined") {
    return { width: 375, height: 812, scale: 1, fontScale: 1 }
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight,
    scale: window.devicePixelRatio || 1,
    fontScale: 1,
  }
}

export const Dimensions = {
  get(dim: "window" | "screen") {
    void dim
    return getWindowSize()
  },
  addEventListener(_type: string, _handler: () => void) {
    if (typeof window === "undefined") return { remove: () => {} }
    const handler = () => _handler()
    window.addEventListener("resize", handler)
    return { remove: () => window.removeEventListener("resize", handler) }
  },
}
